/**
 * Order-deadline countdown badge.
 *
 * Counts down to the next occurrence of `cutoffHour` (24-hour, visitor-local
 * time) and rolls over to the following day automatically. Visitor-local
 * because the merchant ships globally — a 11pm-shop-tz deadline feels
 * arbitrary to someone in a different region. Local time keeps the urgency
 * personally meaningful (and matches how Amazon presents it).
 */
class OrderDeadline extends HTMLElement {
  connectedCallback() {
    this.cutoffHour = parseInt(this.dataset.cutoffHour, 10);
    if (!Number.isFinite(this.cutoffHour)) this.cutoffHour = 23;

    this.counter = this.querySelector('[data-counter]');
    if (!this.counter) return;

    this.#tick();
    // 1s cadence is enough — the counter only renders down to seconds.
    this.timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    if (this.timer) clearInterval(this.timer);
  }

  #nextCutoff() {
    const now = new Date();
    const cutoff = new Date(now);
    cutoff.setHours(this.cutoffHour, 0, 0, 0);
    if (cutoff.getTime() <= now.getTime()) {
      cutoff.setDate(cutoff.getDate() + 1);
    }
    return cutoff.getTime();
  }

  #tick() {
    let remaining = this.#nextCutoff() - Date.now();
    if (remaining < 0) remaining = 0;

    const h = Math.floor(remaining / 3600000);
    remaining -= h * 3600000;
    const m = Math.floor(remaining / 60000);
    remaining -= m * 60000;
    const s = Math.floor(remaining / 1000);

    this.counter.textContent = `${h}h ${pad(m)}m ${pad(s)}s`;
  }
}

function pad(n) {
  return n < 10 ? `0${n}` : String(n);
}

if (!customElements.get('order-deadline')) {
  customElements.define('order-deadline', OrderDeadline);
}
